<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left></left>
            <div id="novel_main">
                <novelLongChapter ref="novelLongChapter" />
            </div>

        </div>
        <loadingStatus v-if="loading" />
    </div>
</template>

<script>
import lNApi from '@/api/longNovel'
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import novelLongChapter from '@/components/long_novel/novel_long_chapter.vue' //分卷管理
import loadingStatus from '@/components/loading_status.vue' //加载
import { EncryptionUtil } from '@/utils/encrypt'
export default {
    components: {
        top, left, novelLongChapter, loadingStatus
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
            loading: true, //加载
        }
    },
    created() {
        let pageNum = this.$route.query?.pageNum || 1
        let novelInfo = this.$route.query?.novelInfo ? EncryptionUtil.decrypt(this.$route.query.novelInfo) : {}
        let seriesInfo = this.$route.query?.seriesInfo ? EncryptionUtil.decrypt(this.$route.query.seriesInfo) : {}
        let isShowZG = this.$route.query?.isShowZG
        if (seriesInfo.id) {
            //章节详情
            console.log('seriesInfo=', seriesInfo)
            lNApi.seriesDetail({ id: seriesInfo.id }).then(res => {
                if (res.code === 200) {
                    //章节列表
                    console.log('进入章节列表=', res.data)
                    this.$nextTick(() => {
                        if (this.$refs.novelLongChapter) {
                            console.log('执行章节列表接口')
                            this.$refs.novelLongChapter.getChapterList({seriesInfo:res.data,pageNum: Number(pageNum),isShowZG:isShowZG,novelInfo})
                        }
                    })
                } else {
                    this.$message.warning(res.msg)
                }
            })
            this.loading = false
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        toNovellist() {
            this.$router.replace({ path: '/novel', query: {} })
        }
    }
}
</script>

<style>
#novel {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

.mian {
    display: flex;
    min-width: 1500px;
}
</style>